import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Panel from '../../../shared/Panel'
import Text from '../../../shared/Text'
import { If } from '../../../../deprecated/Conditionals'
import Autocomplete from '../../../shared/Autocomplete'

import styles from './EnterAddress.module.scss'

const propTypes = {
  onAddress: PropTypes.func.isRequired,
  hasHomes: PropTypes.bool,
}

const Explain = props => (
  <Text
    size='s'
    align='center'
    variant='neutralCool'
    variantCount='600'
    {...props}
  />
)

const EnterAddress = ({ hasHomes, onAddress }) => (
  <>
    <Text.Headline>
      <If condition={hasHomes}>
        <FormattedMessage
          id='NewHome.EnterAddress.heading.hasHomes'
          defaultMessage='Own another home?'
        />
      </If>
      <If condition={!hasHomes}>
        <FormattedMessage
          id='NewHome.EnterAddress.heading'
          defaultMessage="What's your home worth?"
        />
      </If>
    </Text.Headline>
    <Explain className={styles.one}>
      <If condition={hasHomes}>
        <FormattedMessage
          id='NewHome.EnterAddress.explain.hasHomes'
          defaultMessage='Add your homes address to receive another monthly digest.'
        />
      </If>
      <If condition={!hasHomes}>
        <FormattedMessage
          id='NewHome.EnterAddress.explain'
          defaultMessage='Track your home value and receive personalized tips and tricks on how to build wealth with your home.'
        />
      </If>
    </Explain>

    <Autocomplete className={styles.input} onSubmit={onAddress} />

    <If condition={!hasHomes}>
      <Panel.Footer>
        <Text align='center' variant='neutralCool' variantCount='900' paragraph>
          <FormattedMessage
            id='NewHome.EnterAddress.footerHeading'
            defaultMessage="Don't own a home yet?"
          />
        </Text>
        <Explain paragraph>
          <FormattedMessage
            id='NewHome.EnterAddress.footerExplain'
            defaultMessage="Come back after you buy and we'll help you make the most of it!"
          />
        </Explain>
      </Panel.Footer>
    </If>
  </>
)

EnterAddress.propTypes = propTypes

export default EnterAddress
